<div class="orderType-container">
  <div class="orderType-list" *ngFor="let item of orderTypeList" (click)="orderTypeChange(item.value)"
    [ngClass]="{'selectedOrderType': (selectedOrderType | lowercase ) == (item.value | lowercase )}">
    <div class="orderTypeIcon-background">
      <i [ngClass]="item.icon"></i>
    </div>
    <h1>{{item.name | translate}}</h1>
  </div>
</div>
